export default () => {

    const notice = document.querySelector('[data-header-notice]');
    const close = document.querySelector('[data-header-notice-close]');
    const NOTICE_CLOSED = 'NOTICE_CLOSED';

    if (notice && close) {

        let date = window.localStorage.getItem(NOTICE_CLOSED);
        let now = Date.now();

        if (date) {
            const diff = (now - date) / (1000 * 3600 * 24);
            if (diff < 1) {
                notice.classList.add('hidden');
            } else {
                notice.classList.remove('hidden');
            }
        } else {
            notice.classList.remove('hidden');
        }

        close.addEventListener('click', (e) => {
            e.preventDefault();
            notice.classList.add('hidden');
            window.localStorage.setItem(NOTICE_CLOSED, now);
            return false;
        });

    }

}
